import React from 'react'
import { Accordion, AccordionSummary, Typography, makeStyles, Theme, createStyles, AccordionDetails } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InvoiceEditForm from './edit/InvoiceEditForm';
import VisitsInfo from './details/VisitsInfo';
import DetailsEditForm from './edit/DetailsEditForm';
import { typeDetailsForm, typeForm } from '../../../pages/ContractRegist';
import { typeCisDepartmentList, typeCisUserList, typeContractList } from '../../../api/helpline/keiyaku';
import { typeCategory, typeMemberList } from '../../../api/helpline/master';
import BasicEditForm from './edit/BasicEditForm';
import { typeVisits } from '../../../api/helpline/qa';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
  }),
);

interface Prop {
  reqbasicItem: {
    custmNo: boolean; custmDepNo: boolean; keiyakuNo: boolean; orderNo: boolean; keiyakuClsCd: boolean; keiyakuStartTs: boolean; renewalMonth: boolean; keiyakuPersonCd: boolean; keiyakuDeposit: boolean; totalPrice: boolean; machineSettingZipCd: boolean; machineSettingAddress: boolean;
  },
  handleChangeForm: (event: React.ChangeEvent<{ value: unknown; name?: string | undefined; }>) => void,
  form: typeForm | null | undefined,
  _onInitialized: (sender: any) => void,
  contractList: typeContractList[] | undefined,
  handleChangeKeiyakuCd: (keiyakuObj: typeContractList) => void,
  chipDelete: (i: number, name: string) => void,
  monthList: number[],
  memberList: typeMemberList[] | undefined,
  handleChangeUserCd: (memberObj: typeMemberList) => void,
  payment: typeCategory[],
  cisUserList: typeCisUserList[],
  handleChangeSalesPersonCd: (salesPersonCdObj: typeCisUserList | null) => void,
  handleChangeChecked: (event: React.ChangeEvent<HTMLInputElement>) => void,
  selectmember: typeMemberList | undefined,
  checkbasicItem: { keiyakuNo: boolean; orderNo: boolean; keiyakuDeposit: boolean; totalPrice: boolean; incidentDeposit: boolean; visitCount: boolean; incidentCount: boolean; machineSettingZipCd: boolean; incidentAddCount: boolean; incidentUsedCount: boolean; }
  selectKeiyaku: typeContractList | undefined,
  detailsform: typeDetailsForm[] | null | undefined,
  displayIncident: boolean,
  checkinvoiceItem: { monthlyPrice: boolean; monthlyPrice2: boolean; demandZipCd: boolean; },
  reqinvoiceItem: {
    demandZipCd: boolean; demandAddress: boolean; demandCompanyName: boolean; demandPersonName: boolean; demandMonth: boolean; actionSeDeptCd: boolean;
  },
  monthSelect: { value: string, name: string }[],
  handleChangeDemandMonth: (event: React.ChangeEvent<HTMLInputElement>) => void,
  demandSelect: string,
  cisDepartmentList: typeCisDepartmentList[],
  handleChangeDepartmentCd: (departmentObj: typeCisDepartmentList) => void,
  mailservice: boolean[] | null,
  renewalMonthSelect: { value: string, name: string }[],
  handleChangeRenewalMonth: (event: React.ChangeEvent<HTMLInputElement>) => void,
  renewalSelect: string,
  _onValueChanged: (sender: { value: Date; }) => void,
  kaiyakuTs: Date | null,
  incidentUsedCountReset: () => void,
  visitsInfo: typeVisits[] | undefined,
  handleClickQAno: (num: string) => void,
}

const ContractEditForm: React.FC<Prop> = (props) => {
  const classes = useStyles()
  const { reqbasicItem, handleChangeForm, form, _onInitialized, contractList, handleChangeKeiyakuCd, chipDelete, monthList, memberList, handleChangeUserCd, payment, cisUserList, handleChangeSalesPersonCd, handleChangeChecked, selectmember, checkbasicItem, displayIncident, detailsform, reqinvoiceItem, checkinvoiceItem, monthSelect, handleChangeDemandMonth, demandSelect, handleChangeDepartmentCd, cisDepartmentList, mailservice, renewalMonthSelect, handleChangeRenewalMonth, renewalSelect, _onValueChanged, kaiyakuTs, incidentUsedCountReset, visitsInfo, handleClickQAno } = props

  return (
    <React.Fragment>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="basicInfo-content"
          id="basicInfo-header"
        >
          <Typography className={classes.heading}>契約基本情報</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <BasicEditForm reqbasicItem={reqbasicItem} handleChangeForm={handleChangeForm} form={form} _onInitialized={_onInitialized} contractList={contractList} handleChangeKeiyakuCd={handleChangeKeiyakuCd} monthList={monthList} chipDelete={chipDelete} memberList={memberList} handleChangeUserCd={handleChangeUserCd} payment={payment} cisUserList={cisUserList} handleChangeSalesPersonCd={handleChangeSalesPersonCd} handleChangeChecked={handleChangeChecked} selectmember={selectmember} checkbasicItem={checkbasicItem} displayIncident={displayIncident} mailservice={mailservice} renewalMonthSelect={renewalMonthSelect} handleChangeRenewalMonth={handleChangeRenewalMonth} renewalSelect={renewalSelect} _onValueChanged={_onValueChanged} kaiyakuTs={kaiyakuTs} incidentUsedCountReset={incidentUsedCountReset} />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="detailsInfo-content"
          id="detailsInfo-header"
        >
          <Typography className={classes.heading}>契約詳細情報</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <DetailsEditForm detailsform={detailsform} />
        </AccordionDetails>
      </Accordion>
      <Accordion disabled={visitsInfo?.length === 0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="detailsInfo-content"
          id="detailsInfo-header"
        >
          <Typography className={classes.heading}>訪問状況</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <VisitsInfo visitsInfo={visitsInfo} handleClickQAno={handleClickQAno} />
        </AccordionDetails>
      </Accordion>
      <Accordion >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="detailsInfo-content"
          id="detailsInfo-header"
        >
          <Typography className={classes.heading}>請求情報</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <InvoiceEditForm reqinvoiceItem={reqinvoiceItem} handleChangeForm={handleChangeForm} form={form} chipDelete={chipDelete} monthList={monthList} checkinvoiceItem={checkinvoiceItem} monthSelect={monthSelect} handleChangeDemandMonth={handleChangeDemandMonth} demandSelect={demandSelect} handleChangeDepartmentCd={handleChangeDepartmentCd} cisDepartmentList={cisDepartmentList} />
        </AccordionDetails>
      </Accordion>
    </React.Fragment>
  )
}

export default ContractEditForm
